(function() {
  const swiper_Sections = document.querySelectorAll('[data-swiper_id^="swiper__controls_"]');
     
  if (swiper_Sections) {
    
      function convertBooleanToNumber(value) {
        return value === "true" ? 1 : 0;
      }

    swiper_Sections.forEach(swiper_Section => {
      const swiperId = swiper_Section.dataset.swiper_id;
      const slide_count = parseFloat(swiper_Section.dataset.slide_count);
      const slide_count_tab = parseFloat(swiper_Section.dataset.slide_count_tab);
      const slide_count_mobile = parseFloat(swiper_Section.dataset.slide_count_mobile);
      
      const swiper = new Swiper(`[data-swiper_id="${swiperId}"] .swiper__Container`, {
        freeMode: true,
        observer: true,
        observeParents: true,
        grabCursor: true,
        loop: false,
        preventClicks: true,
        preventClicksPropagation: true,
        pagination: {
          el: `[data-swiper_id="${swiperId}"] .swiper-pagination`,
          clickable: true,
        },
        keyboard: { enabled: true },
        navigation: {
          nextEl: `[data-swiper_id="${swiperId}"] .swiper-button-next`,
          prevEl: `[data-swiper_id="${swiperId}"] .swiper-button-prev`,
        },
        initialSlide: 0,
        slidesPerView: slide_count_mobile,
        slidesPerGroup: slide_count_mobile,
        spaceBetween: 10,
        breakpoints: {
          680: {
            slidesPerView: slide_count_tab,
            slidesPerGroup: slide_count_tab,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: slide_count,
            slidesPerGroup: slide_count,
            spaceBetween: 10,
          },
        },
      });
    });
  }
})();